// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatInvitationDeclineBody = {
  chatInvitationId: string;
};

export type typeChatInvitationDeclineOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isDeclined: boolean };
};

export type typeChatInvitationDeclineOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatInvitationDeclineOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatInvitationDeclineOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatInvitationDeclineBody = {
  type: "object",
  properties: {
    chatInvitationId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["chatInvitationId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatInvitationDecline(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatInvitationDeclineBody);
  }

  return async function postChatInvitationDecline(
    payload: typeChatInvitationDeclineBody,
  ): Promise<
    typeChatInvitationDeclineOutput200 | typeChatInvitationDeclineOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatInvitationDecline" failed before calling the network. #25486310df00`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#25486310df00" },
        },
        data: null,
      } as typeChatInvitationDeclineOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat-invitation/decline`,
      httpMethod: "POST",
      options,
    })) as
      typeChatInvitationDeclineOutput200 | typeChatInvitationDeclineOutput400;
  };
}
